import { getRuntime } from "@next-core/brick-kit";

getRuntime().registerLazyBricks(
"presentational-bricks.code-editor",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/code-editor.dd92" */
    "../code-editor"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.crontab-display",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/crontab-display.dd92" */
    "../crontab-display"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.brick-code-display",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/brick-code-display.dd92" */
    "../brick-code-display"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.card-item",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/card-item.dd92" */
    "../card-item"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.brick-collapse-card",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/brick-collapse-card.dd92" */
    "../brick-collapse-card"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.brick-placeholder",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/brick-placeholder.dd92" */
    "../brick-placeholder"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.single-field-edit",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/single-field-edit.dd92" */
    "../single-field-edit"
  )
);

getRuntime().registerLazyBricks(
"presentational-bricks.qrcode-download",
() =>
  import(
    /* webpackChunkName: "lazy-bricks/qrcode-download.dd92" */
    "../qrcode-download"
  )
);

getRuntime().registerLazyBricks(
  [
    "presentational-bricks.brick-form",
    "presentational-bricks.markdown-editor",
    "presentational-bricks.markdown-display"
  ],
  () =>
    import(
      /* webpackChunkName: "lazy-bricks/~bricks-use-form-and-markdown.dd92" */
      "./bricks-use-form-and-markdown"
    )
);

getRuntime().registerLazyBricks(
  [
    "presentational-bricks.modal-confirm",
    "presentational-bricks.statistic-card"
  ],
  () =>
    import(
      /* webpackChunkName: "lazy-bricks/~bricks-use-html-to-react.dd92" */
      "./bricks-use-html-to-react"
    )
);